import { gql } from '__generated__';

export default gql(`
  mutation ActivatePurchase($id: ID!) {
    activatePurchase(id: $id) {
      id
      active
      ticket {
        id
      }
    }
  }
`);
